<template>
  <div class="video-card">
    <div class="grid-x align-middle">
      <div class="cell shrink">
        <img 
          v-if="posterImage" 
          :src="posterImage"
          class="square rounded">
      </div>
      <div class="cell auto">
        <h5 class="no-margin">{{ video.title }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCard',
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  computed: {
    posterImage () {
      if (this.video.poster_image) {
        return this.video.poster_image.small
      }
      return false
    }
  }
}
</script>
